import { FC, useState } from 'react';
import { MainLayout } from 'pages/MainLayout';
import { DriverDetailsForm } from './DriverDetailsForm';
import { Button } from '@/components/ui/button';
import { useParams } from 'react-router-dom';
import { trpc } from 'src/trpc';
import { Loader } from 'src/components/Loader';
import { Driver } from 'src/trpc';
import { Notes } from 'src/components/Notes';
import { useToast } from 'src/components/useToast';

export const DriverDetailsPage: FC = () => {
  const [isFormValid, setIsFormValid] = useState(false);
  const params = useParams<{ id: string }>();
  const { data, isLoading } = trpc.admin.driver.getDriver.useQuery(params.id!);
  const { successToast, errorToast } = useToast();

  const handleSuccess = () => {
    successToast({
      title: 'Driver updated',
      description: 'Driver details have been successfully updated',
    });
  };

  const handleError = (error: Error) => {
    errorToast({
      title: 'Failed to update driver',
      description: error.message || 'An error occurred while updating the driver details',
    });
  };

  if (isLoading) {
    return (
      <MainLayout>
        <Loader title="Getting driver" />
      </MainLayout>
    );
  }
  return (
    <MainLayout title="Drivers">
      <div className="flex flex-row gap-10 w-full">
        <div className="w-1/2 bg-white p-6">
          <DriverDetailsForm
            driver={data as unknown as Driver}
            onSuccess={handleSuccess}
            onError={handleError}
            onStateChange={(state) => setIsFormValid(state.isValid)}
          >
            <div className="flex flex-row justify-start gap-4">
              <div>
                <Button disabled={!isFormValid} className="w-full text-white" type="submit">
                  Save Changes
                </Button>
              </div>
            </div>
          </DriverDetailsForm>
        </div>
        <div className="w-1/3">
          <Notes entityId={params.id!} origin="driver" />
        </div>
      </div>
    </MainLayout>
  );
};
